import type { Action } from '@0xtorch/core'
import { AssetNotFoundException } from '../../errors'
import type { FetchApiData } from '../../types'
import { createGetAsset } from '../../utils/createGetAsset'
import { hyperliquidAccountCategory } from '../constants'
import { createClient } from '../createClient'
import { parseHyperliquidActionEvidence } from '../parseActionEvidence'
import { responseSchema } from './schema'

// README 処理仕様に基づく実装
export const fetchApiData: FetchApiData = async ({
  apiKey,
  assets,
  config,
  createHeaders,
  proxy,
  symbolAssetMap,
}) => {
  const getAsset = createGetAsset({ assets, symbolAssetMap })

  const client = createClient({
    apiKey,
    createHeaders,
    proxy,
  })

  const response = await client.run({
    method: 'POST',
    path: '/info',
    body: {
      type: 'delegatorRewards',
    },
    responseSchema,
  })

  // 昇順 sort by time
  const sortedRewards = response.sort((a, b) => a.time - b.time)

  let fetchedFrom: number | undefined
  let fetchedTo: number | undefined
  const actions: Action[] = []
  const sources: string[] = [] // README: sources は空配列

  for (const item of sortedRewards) {
    // fetchedFrom / fetchedTo 更新
    fetchedFrom =
      fetchedFrom === undefined ? item.time : Math.min(fetchedFrom, item.time)
    fetchedTo =
      fetchedTo === undefined ? item.time : Math.max(fetchedTo, item.time)

    // asset 取得 (固定で HYPE)
    const asset = getAsset('HYPE')
    if (!asset) {
      throw new AssetNotFoundException('HYPE')
    }

    if (item.totalAmount.value > 0n) {
      actions.push({
        comment: item.source,
        evidence: 'system-rule',
        order: 0,
        source: `${hyperliquidAccountCategory}_${config.type}_${item.source}_${item.time}`,
        type: 'staking-reward',
        timestamp: item.time,
        transfers: [
          {
            asset,
            amount: item.totalAmount,
            direction: 'in',
          },
        ],
      })
    } else if (item.totalAmount.value < 0n) {
      throw new Error('totalAmount < 0 is not supported')
    }
  }

  // actions を timestamp 昇順ソート
  const sortedActions = actions.sort((a, b) => a.timestamp - b.timestamp)

  return {
    actions: sortedActions.map((action) =>
      parseHyperliquidActionEvidence(action),
    ),
    count: response.length,
    from: fetchedFrom,
    sources,
    stopped: false,
    to: fetchedTo,
  }
}
